import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Region } from "@common/models/region";
import { environment } from "environments/environment";
@Injectable({ providedIn: "root" })
export class RegionService {
  constructor(private _htpp: HttpClient) {}

  getAll() {
    return this._htpp.get<Region[]>(`${environment.commonApiUrl}/api/region`);
  }

  getLiteByName(name: string){
    return this._htpp.get<Region[]>(`${environment.commonApiUrl}/api/region/lite/${name}`);
  }
}
